import React from 'react';
import { Loader2, AlertTriangle } from 'lucide-react';
import BannerAltreFontiPage from '../../components/altre-fonti/BannerAltreFontiPage';
import ContainerAltreFontiPage from '../../components/altre-fonti/ContainerAltreFontiPage';
import { useGeneralDocumentClasses } from '../../api/hooks/useGeneralDocumentClasses';

const AltreFontiPage = () => {
  const { documents, loading, error } = useGeneralDocumentClasses();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 h-screen">
        <Loader2 className="w-8 h-8 text-textPrimary/40 animate-spin" />
        <p className="text-xs text-textMuted">Caricamento delle classi documento…</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-background min-h-screen">
      <BannerAltreFontiPage />
      <div className="px-8 lg:px-16 py-8">
        {error && (
          <div className="flex items-start gap-2 p-3 rounded-xl border border-red-200 bg-red-50 text-xs text-red-800 mb-6">
            <AlertTriangle className="w-4 h-4 shrink-0 mt-px" />
            <span className="break-words">{error}</span>
          </div>
        )}
        <ContainerAltreFontiPage documents={documents} />
      </div>
    </div>
  );
};

export default AltreFontiPage;
